import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import componentClassNames from './styles/ScreenNotification.scss';

export default class ScreenNotification extends Component {
    render() {
        const jsx = (
            <div className={componentClassNames.ScreenNotification}>
                {this.props.children}
            </div>
        );
        return ReactDOM.createPortal(jsx, document.body);
    }
}
